import { createFeature, createReducer, on } from '@ngrx/store';

import { PayloadsActions } from './payloads.actions';
import { PayloadDto } from '@stores/payloads';

export interface PayloadsState {
  error: string | null;
  loading: boolean;
  payloads: PayloadDto[];
}

export const initialState: PayloadsState = {
  error: null,
  loading: false,
  payloads: [],
};

const reducer = createReducer(
  initialState,
  on(PayloadsActions.getPayloads, (state) => ({ ...state, loading: true })),
  on(PayloadsActions.getPayloadsSuccess, (state, { payloads }) => ({
    ...state,
    payloads: payloads?.map((p) => ({ ...p })) ?? [],
    loading: false,
  })),
  on(PayloadsActions.getPayloadsFailure, (state, { error }) => ({
    ...state,
    error: String(error),
    loading: false,
  })),
);

export const payloadsFeature = createFeature({
  name: 'payloads',
  reducer,
});
